<script setup lang="ts">
import { VPModal } from '@vp/vue-components';
import { useGettext } from 'vue3-gettext';

type Props = {
  show: boolean;
};

defineProps<Props>();

defineEmits<{
  (e: 'update:show', show: boolean): void;
}>();

const { $gettext } = useGettext();
</script>

<template>
  <VPModal
    :show="show"
    :title="$gettext('Time is up!')"
    :confirm-label="$gettext('Choose tickets again')"
    show-close-button
    data-testid="cart-expired-modal"
    @update:show="$emit('update:show', $event)"
  >
    <!-- VPModal renders no dialog landmark, so the copy carries its own live region. -->
    <p
      role="alert"
      class="text-center"
    >
      {{ $gettext('Your reserved tickets have been released and your cart is now empty. Nothing was charged.') }}
    </p>
  </VPModal>
</template>
